import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import Image from '@base/FutureImage';
import Typography from 'aquilla/core/atoms/Typography';
import RightChevron from 'aquilla/icons/actions/RightChevron';
import useWindowSize from '@hooks/useWindowSize';
import pushRoute from '@utils/pushRoute';

const Container = styled.div`
  width: 363px;
  height: 130px;
  border-width: 1px;
  border-style: solid;
  border-color: var(--color-i-divider);
  border-radius: ${Spacings.SPACING_2B};
  background-color: var(--color-i-white);
  display: flex;
  flex-direction: row;
  box-shadow: 0px ${Spacings.SPACING_2} ${Spacings.SPACING_6}
    rgba(0, 0, 0, 0.06);
  position: relative;
  cursor: pointer;
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
  ${mediaQuery.uptoTablet} {
    width: 100%;
  }
  :hover {
    background-color: var(--color-i-gray-98);
    border-color: var(--color-i-black);
  }
`;

const TextWrapper = styled.div`
  width: 100%;
  max-width: 248px;
  display: flex;
  flex-direction: column;
`;

const TitleContainer = styled.div`
  height: fit-content;
  align-items: center;
  display: flex;
  margin-left: ${Spacings.SPACING_6B};
  margin-top: ${Spacings.SPACING_6B};
`;

const ArrowContainer = styled.div`
  display: flex;
  align-items: flex-end;
  height: ${Spacings.SPACING_6B};
  width: ${Spacings.SPACING_6B};
  margin-left: ${Spacings.SPACING_6};
`;

const SubTitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${Spacings.SPACING_6B};
`;

const GoalImgContainer = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: end;
  justify-content: end;
  overflow: hidden;
`;

const GoalImgWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 0px;
  border-style: solid;
  width: 108px;
  height: 108px;
  border-color: var(--color-i-divider);
  border-radius: ${Spacings.SPACING_14B};
  background-color: var(--color-i-violet-dark-1);
  margin-right: -${Spacings.SPACING_4B};
  margin-bottom: -${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    width: ${Spacings.SPACING_14B};
    height: ${Spacings.SPACING_14B};
    border-radius: ${Spacings.SPACING_7B};
    margin-right: -${Spacings.SPACING_2B};
    margin-bottom: -${Spacings.SPACING_1B};
  }
`;

const GoalCard = ({ goalCardData }) => {
  const { isMobile } = useWindowSize();

  const handleGoalRouting = (goalUID) => {
    pushRoute({
      pathname: '/all-centre/[goalUID]',
      query: {
        goalUID
      }
    });
  };

  return (
    <Container
      onClick={() => {
        handleGoalRouting(goalCardData?.goalUid);
      }}
    >
      <TextWrapper>
        <TitleContainer>
          <Typography variant="h4">{goalCardData?.goalName}</Typography>
          <ArrowContainer>
            <RightChevron color="var(--color-i-gray-13)" />
          </ArrowContainer>
        </TitleContainer>
        <SubTitleContainer>
          <Typography variant="p2" color="var(--color-i-gray-13)">
            {goalCardData?.subtext}
          </Typography>
        </SubTitleContainer>
      </TextWrapper>
      <GoalImgContainer>
        <GoalImgWrapper>
          <Image
            src={goalCardData?.goalImage}
            width={isMobile ? 20 : 40}
            height={isMobile ? 25 : 50}
            alt="Goal Icon"
            style={{ display: 'flex' }}
          />
        </GoalImgWrapper>
      </GoalImgContainer>
    </Container>
  );
};

export default GoalCard;
